"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('./SoulModule');
/**
 * Authorization flow by Keycloak
 * @extends SoulModule
 */


var Keycloak =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Keycloak, _SoulModule);

  function Keycloak(data, me) {
    var _this;

    _classCallCheck(this, Keycloak);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Keycloak).call(this, data));
    _this._me = me;
    _this.ignoreRefresh = false;
    _this.defaultDelay = 2000;
    _this.maxMigrationDelay = 4000;
    _this.retryStatuses = [429, 500];
    return _this;
  }
  /**
  * migrate token key from hmac to keycloak
  * @param {Object} params
  * @param {string} params.userId
  * @param {string} params.sessionToken
  */


  _createClass(Keycloak, [{
    key: "migrateSessionKey",
    value: function migrateSessionKey(_ref) {
      var _this2 = this;

      var userId = _ref.userId,
          sessionToken = _ref.sessionToken;
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultDelay;
      this.ignoreRefresh = true;
      return this.api.post('auth-companion-service/v1/migrate-session-key/', {
        api_key: this.apiKey,
        user_id: userId,
        session_key: sessionToken
      }).then(function (authorization) {
        _this2.storage.saveAuthorizationTokens(authorization);

        _this2.storage.set('sessionToken', '');
      })["catch"](function (error) {
        if (_this2.retryStatuses.includes(error.status) && delay <= _this2.maxMigrationDelay) {
          return _this2.sleep(delay).then(function () {
            return _this2.migrateSessionKey({
              userId: userId,
              sessionToken: sessionToken
            }, delay * 2);
          });
        }
      })["finally"](function () {
        _this2.ignoreRefresh = false;
      });
    }
  }, {
    key: "sleep",
    value: function sleep(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
    /**
    * migrate token key from keycloak to hmac
    * @param {Object} params
    * @param {string} params.userId
    * @param {string} params.accessToken
    */

  }, {
    key: "rollbackSessionKey",
    value: function rollbackSessionKey(_ref2) {
      var _this3 = this;

      var userId = _ref2.userId,
          accessToken = _ref2.accessToken;
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultDelay;
      return this.api.post('auth-companion-service/v1/rollback-session-key/', {
        api_key: this.apiKey,
        user_id: userId,
        access_token: accessToken
      }).then(function (data) {
        _this3.storage.set('sessionToken', data.sessionToken);

        _this3.storage.set('accessToken', '');

        _this3.storage.set('refreshToken', '');
      })["catch"](function (error) {
        if (_this3.retryStatuses.includes(error.status) && delay <= _this3.maxMigrationDelay) {
          return _this3.sleep(delay).then(function () {
            return _this3.rollbackSessionKey({
              userId: userId,
              accessToken: accessToken
            }, delay * 2);
          });
        }
      });
    }
  }, {
    key: "refreshToken",
    value: function refreshToken() {
      var _this4 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defaultDelay;
      var refreshToken = this.storage.get('refreshToken');
      this.ignoreRefresh = true;
      this.storage.setRefreshInProgress(true);
      return this.api.post('auth-companion-service/v1/refresh-token/', {
        api_key: this.apiKey,
        refresh_token: refreshToken
      }).then(function (authorization) {
        _this4.storage.saveAuthorizationTokens(authorization);
      })["catch"](function (error) {
        if (error.status === 429 && delay <= _this4.maxMigrationDelay) {
          return _this4.sleep(delay).then(function () {
            return _this4.refreshToken(delay * 2, true);
          });
        } else if (error.status === 500) {
          return {
            error: error
          };
        } else if (error.status) {
          _this4.storage.removeSession();
        }
      })["finally"](function () {
        _this4.ignoreRefresh = false;

        _this4.storage.setRefreshInProgress(false);
      });
    }
    /**
    * check access token and refresh if needed 
    * @param {Object} params
    * @param {string} params.refreshToken
    */

  }, {
    key: "checkAndRefreshToken",
    value: function checkAndRefreshToken() {
      var _this5 = this;

      var refreshToken = this.storage.get('refreshToken');
      var expires = Number(this.storage.get('accessExpiresIn'));

      if (!refreshToken || expires - Date.now() > 10000) {
        return;
      }

      if (this.ignoreRefresh) {
        var wait = function wait() {
          return _this5.sleep(200).then(function () {
            if (_this5.storage.storage.refreshInProgress === true) {
              return wait();
            } else {
              return;
            }
          });
        };

        return wait();
      }

      return this.refreshToken();
    }
    /**
    * send verification code to email
    * @param {Object} params
    * @param {string} params.email
    */

  }, {
    key: "requestEmailCode",
    value: function requestEmailCode(_ref3) {
      var email = _ref3.email;
      return this.api.post('auth-companion-service/v1/code/', {
        api_key: this.apiKey,
        email: email
      });
    }
    /**
    * verify code from email
    * @param {Object} params
    * @param {string} params.email
    * @param {string} params.code
    */

  }, {
    key: "verifyEmailCode",
    value: function verifyEmailCode(_ref4) {
      var _this6 = this;

      var email = _ref4.email,
          code = _ref4.code;
      return this.api.post('auth-companion-service/v1/code/', {
        api_key: this.apiKey,
        email: email,
        code: code
      }).then(function (authorization) {
        _this6.storage.saveAuthorizationTokens(authorization);

        return _this6._me.get().then(function (meResponse) {
          _this6.storage.saveSession(meResponse);

          return _objectSpread({}, meResponse, {
            authorization: authorization
          });
        });
      });
    }
    /**
    * get OAuth params
    * @param {Object} params
    * @param {string} params.method facebook | apple-web | google-web | huawei
    * @param {string} params.redirectUri
    */

  }, {
    key: "startSessionViaOAuth",
    value: function startSessionViaOAuth(_ref5) {
      var method = _ref5.method,
          redirectUri = _ref5.redirectUri;
      return this.api.post('auth-companion-service/v1/start-session/', {
        api_key: this.apiKey,
        method: method,
        redirect_uri: redirectUri
      });
    }
    /**
    * get token from OAuth params 
    * @param {Object} params Params from startSessionViaOAuth response
    * @param {string} params.code
    * @param {string} params.state
    * @param {string} params.session
    */

  }, {
    key: "getTokenFromOAuth",
    value: function getTokenFromOAuth(_ref6) {
      var _this7 = this;

      var code = _ref6.code,
          state = _ref6.state,
          session = _ref6.session;
      return this.api.post('auth-companion-service/v1/get-token/', {
        api_key: this.apiKey,
        code: code,
        state: state,
        session: session
      }).then(function (authorization) {
        _this7.storage.saveAuthorizationTokens(authorization);

        return _this7._me.get().then(function (meResponse) {
          _this7.storage.saveSession(meResponse);

          return _objectSpread({}, meResponse, {
            authorization: authorization
          });
        });
      });
    }
    /**
    * exchange token from OAuth
    * @param {Object} params
    * @param {string} params.method facebook | apple-web | google-web | huawei-web
    * @param {string} params.accessToken token from OAuth
    * @param {string} params.idToken token from OAuth
    */

  }, {
    key: "exchangeToken",
    value: function exchangeToken(_ref7) {
      var _this8 = this;

      var method = _ref7.method,
          accessToken = _ref7.accessToken,
          idToken = _ref7.idToken;
      var token = accessToken ? {
        access_token: accessToken
      } : {
        id_token: idToken
      };
      return this.api.post('auth-companion-service/v1/exchange-token/', _objectSpread({
        api_key: this.apiKey,
        method: method
      }, token)).then(function (authorization) {
        _this8.storage.saveAuthorizationTokens(authorization);

        return _this8._me.get().then(function (meResponse) {
          _this8.storage.saveSession(meResponse);

          return _objectSpread({}, meResponse, {
            authorization: authorization
          });
        });
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this9 = this;

      return this.api.post('auth-companion-service/v1/logout/', {
        api_key: this.apiKey
      }).then(function () {
        _this9.storage.removeSession();
      });
    }
  }]);

  return Keycloak;
}(SoulModule);

module.exports = Keycloak;